import React, { createContext, useContext, ReactNode } from 'react';
import { useAppTrackingTransparency, ATTStatus, isTrackingAuthorized } from '@/hooks/useAppTrackingTransparency';

interface ATTContextValue {
  status: ATTStatus;
  isLoading: boolean;
  hasRequestedPermission: boolean;
  isTrackingAuthorized: boolean;
}

const ATTContext = createContext<ATTContextValue | null>(null);

interface ATTProviderProps {
  children: ReactNode;
}

export function ATTProvider({ children }: ATTProviderProps) {
  const { status, isLoading, hasRequestedPermission } = useAppTrackingTransparency();

  const value: ATTContextValue = {
    status,
    isLoading,
    hasRequestedPermission,
    isTrackingAuthorized: isTrackingAuthorized(status),
  };

  return (
    <ATTContext.Provider value={value}>
      {children}
    </ATTContext.Provider>
  );
}

export function useATTContext() {
  const context = useContext(ATTContext);
  if (!context) {
    throw new Error('useATTContext must be used within ATTProvider');
  }
  return context;
}
